export const darkModeStyle =
    "dark:bg-slate-600 dark:border-slate-600 dark:text-slate-100";
